import React, { useEffect, useState } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import { useNavigate, useParams } from "react-router-dom";
import { FaTruck, FaUserAlt } from "react-icons/fa";
import ListaVisita from "../../Componentes/ListaVisita";
import "./styles.css";

const Motorista = () => {
  const [filtro] = useState("");
  const { IDmotorista } = useParams();
  const [, setDadosMotorista] = useState([]);
  const [nomeMotorista, setNomeMotorista] = useState("-");
  const [veiculoMotorista, setVeiculoMotorista] = useState("-");
  const [dadosVisitas, setDadosVisitas] = useState([]);
  const [lote, setLote] = useState("");
  const [ordenacao, setOrdenacao] = useState("nome");
  const [totalVisitas, setTotalVisitas] = useState(0);
  const [visitasEmAndamento, setVisitasEmAndamento] = useState(0);
  const [, setVisitasConcluidas] = useState(0);
  const [somaQuantidadeTotal, setSomaQuantidadeTotal] = useState(0);
  const [somaQuantidadeEntregue, setSomaQuantidadeEntregue] = useState(0);
  const [somaValorTotal, setSomaValorTotal] = useState(0);
  const [somaValorEntregue, setSomaValorEntregue] = useState(0);
  const [progresso, setProgresso] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
    carregaDadosMotorista(IDmotorista);
  }, [IDmotorista, navigate]);

  useEffect(() => {
    carregaListaVisitas(IDmotorista, filtro);

    const intervalo = setInterval(() => {
      carregaListaVisitas(IDmotorista, filtro);
    }, 60000);

    return () => clearInterval(intervalo);
  }, [IDmotorista, filtro]);

  async function carregaDadosMotorista(id) {
    const retorno = await buscaMotorista(id);
    if (retorno?.data) {
      setDadosMotorista(retorno.data);
      setNomeMotorista(
        `${String(retorno.data.Usuario.IDusuario).padStart(6, "0")}  |  ${
          retorno.data.Usuario.pessoa.nome
        }  |  CPF: ${formatCPF(retorno.data.Usuario.pessoa.cpf)}`
      );
      if (retorno.data.Usuario.lote) {
        setLote(retorno.data.Usuario.lote.IDlote);
      }
    }
  }

  async function carregaListaVisitas(idMotoristaAtual, filtroAtual) {
    const retorno = await buscaVisitas(idMotoristaAtual, filtroAtual);

    if (retorno && retorno.data && retorno.data.Lote) {
      const visitas = retorno.data.Lote.resultVisita || [];
      setDadosVisitas(visitas);

      if (retorno.data.Lote.modeloVeiculo) {
        setVeiculoMotorista(
          `${retorno.data.Lote.modeloVeiculo} | PLACA: ${retorno.data.Lote.placaVeiculo}`
        );
      }

      const total = visitas.length;
      const andamento = visitas.filter((visita) => visita.situacaovisita === 1).length;

      const totalQuantidade = visitas.reduce(
        (acc, visita) => acc + parseFloat(visita.quantidade || 0),
        0
      );

      const quantidadeEntregue = visitas.reduce((acc, visita) => {
        if (visita.situacaovisita === 1) {
          return acc + parseFloat(visita.quantidade || 0);
        }
        return acc;
      }, 0);

      const totalValor = visitas.reduce(
        (acc, visita) => acc + parseFloat(visita.valor || 0),
        0
      );

      const valorEntregue = visitas.reduce((acc, visita) => {
        if (visita.situacaovisita === 1) {
          return acc + parseFloat(visita.valor || 0);
        }
        return acc;
      }, 0);

      setSomaQuantidadeTotal(totalQuantidade);
      setSomaQuantidadeEntregue(quantidadeEntregue);
      setSomaValorTotal(totalValor);
      setSomaValorEntregue(valorEntregue);
      setTotalVisitas(total);
      setVisitasEmAndamento(andamento);
      setVisitasConcluidas(total - andamento);
      setProgresso(total > 0 ? (andamento / total) * 100 : 0);
      return;
    }

    console.error("Erro: Dados de visitas nao encontrados.");
    setDadosVisitas([]);
    setTotalVisitas(0);
    setVisitasEmAndamento(0);
    setVisitasConcluidas(0);
    setProgresso(0);
  }

  async function buscaVisitas(idMotoristaAtual, filtroAtual) {
    try {
      return await api.get(`/visitaMov/${idMotoristaAtual}?filter=${filtroAtual}`);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  function formatCPF(cpf) {
    const cpfLimpo = cpf.replace(/\D/g, "");
    if (cpfLimpo.length !== 11) {
      return cpf;
    }
    return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  async function buscaMotorista(id) {
    try {
      return await api.get(`/usuario/${id}`);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  function abrirHistorico(idUsu) {
    navigate(`/Historico/${idUsu}`);
  }

  const visitasFiltradas =
    ordenacao === "ocorrencia"
      ? dadosVisitas.filter(
          (visita) => visita.movimentos && visita.movimentos.some((mov) => mov.tipo === 5)
        )
      : dadosVisitas;

  const percentualVisitas =
    totalVisitas > 0 ? ((visitasEmAndamento / totalVisitas) * 100).toFixed(2) : "0.00";
  const percentualQuantidade =
    somaQuantidadeTotal > 0
      ? ((somaQuantidadeEntregue / somaQuantidadeTotal) * 100).toFixed(2)
      : "0.00";
  const percentualValor =
    somaValorTotal > 0 ? ((somaValorEntregue / somaValorTotal) * 100).toFixed(2) : "0.00";

  const larguraQuantidade = `${Math.min(Number(percentualQuantidade), 100)}%`;
  const larguraValor = `${Math.min(Number(percentualValor), 100)}%`;
  const itensLegenda = [
    { label: "Nao visitado", className: "nao-visitado" },
    { label: "Em andamento", className: "em-andamento" },
    { label: "Visitado", className: "visitado" },
    { label: "Nao entregue", className: "nao-entregue" },
  ];

  return (
    <div className="menu-container-motorista">
      <MenuLateral />

      <div id="painel_principal_motorista" align="center">
        <div className="motorista-page-header">
          <div className="motorista-page-title-wrap">
            <div className="motorista-page-title-row">
              <span className="motorista-page-kicker">Detalhes da Entrega</span>
              <h5 className="motorista-page-title">Carga n° {lote}</h5>
            </div>
          </div>
          <button
            type="button"
            className="motorista-history-button"
            onClick={() => abrirHistorico(IDmotorista)}
          >
            Ver entregas antigas
          </button>
        </div>

        <div id="painel_motorista" align="left">
          <div className="motorista-panel-grid">
            <div className="motorista-panel-info">
              <div>
                <p style={{ fontSize: "0.7em", fontWeight: "bold" }}>
                  <FaUserAlt /> Motorista:
                </p>
                <p style={{ fontWeight: "normal", marginTop: "-15px", fontSize: "0.9em" }}>
                  {nomeMotorista}
                </p>
              </div>
              <div>
                <p style={{ fontSize: "0.7em", fontWeight: "bold" }}>
                  <FaTruck /> Veiculo:
                </p>
                <p style={{ fontWeight: "normal", marginTop: "-15px", fontSize: "0.9em" }}>
                  {veiculoMotorista}
                </p>
              </div>
            </div>

            <div className="motorista-panel-progress">
              <div className="motorista-overview-progress">
                <div className="motorista-overview-progress-card">
                  <div className="motorista-overview-progress-header">
                    <span className="motorista-overview-progress-title">Andamento geral</span>
                    <strong>{percentualVisitas}%</strong>
                  </div>
                  <div className="motorista-overview-progress-track">
                    <div
                      className="motorista-overview-progress-fill"
                      style={{ width: `${progresso}%` }}
                    />
                  </div>
                  <p className="motorista-overview-progress-caption">
                    {visitasEmAndamento} entregas concluidas de {totalVisitas}
                  </p>
                </div>
              </div>
            </div>

            <div className="motorista-panel-filter">
              <label htmlFor="ordenacao" className="form-label" style={{ fontSize: "1.2em" }}>
                Listar:
              </label>
              <select
                className="form-control"
                id="ordenacao"
                value={ordenacao}
                onChange={(e) => setOrdenacao(e.target.value)}
              >
                <option value="nome">Todas</option>
                <option value="ocorrencia">Com Ocorrencia</option>
              </select>
            </div>

            <div className="motorista-panel-volume">
              <div className="motorista-metric-card">
                <div className="motorista-metric-header">
                  <span className="motorista-metric-title">Volume</span>
                  <strong>{percentualQuantidade}%</strong>
                </div>
                <div className="motorista-metric-track">
                  <div
                    className="motorista-metric-fill"
                    role="progressbar"
                    style={{ width: larguraQuantidade }}
                    aria-valuenow={Number(percentualQuantidade)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <p className="motorista-metric-caption">
                  {somaQuantidadeEntregue} de {somaQuantidadeTotal}
                </p>
              </div>
            </div>

            <div className="motorista-panel-value">
              <div className="motorista-metric-card">
                <div className="motorista-metric-header">
                  <span className="motorista-metric-title">Valor</span>
                  <strong>{percentualValor}%</strong>
                </div>
                <div className="motorista-metric-track">
                  <div
                    className="motorista-metric-fill motorista-metric-fill-value"
                    role="progressbar"
                    style={{ width: larguraValor }}
                    aria-valuenow={Number(percentualValor)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <p className="motorista-metric-caption">
                  {somaValorEntregue.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}{" "}
                  de{" "}
                  {somaValorTotal.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </p>
              </div>
            </div>

            <div className="motorista-panel-legend">
              <div className="motorista-legend-card">
                <p className="motorista-legend-title">Legenda</p>
                <div className="motorista-legend-list">
                  {itensLegenda.map((item) => (
                    <div key={item.label} className="motorista-legend-item">
                      <span className={`motorista-legend-dot ${item.className}`}></span>
                      <span className="motorista-legend-text">{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="div_painel_motorista">
          <ListaVisita listaVisitas={visitasFiltradas} idmotorista={IDmotorista} />
        </div>
      </div>
    </div>
  );
};

export default Motorista;
